//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
export default {
  components: {},
  name: 'rater',
  data() {
    return {
      rate: {
        list: {
          0: true,
          1: true,
          2: true,
          3: true,
          4: true
        },
        score: 0
      }
    };
  },
  methods: {
    ...mapActions([]),
    rater(index) {
      for (let i = 0; i < 5; i++) {
        this.rate.list[i] = true;
      }
      for (let i = 0; i <= index; i++) {
        this.rate.list[i] = false;
      }
      index++;
      this.rate.score = index;
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
